/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * States for the player load mode indicating the current loading phase.
 * Used to track the player's initialization and content loading lifecycle.
 */
export enum PlayerLoadModeStates {
  /**
   * Player has been destroyed and cannot be reused.
   */
  DESTROYED = "DESTROYED",

  /**
   * Player is initialized but no content is loaded.
   */
  NOT_LOADED = "NOT_LOADED",

  /**
   * Content is loaded via MediaSource Extensions (MSE).
   */
  MEDIA_SOURCE = "MEDIA_SOURCE",

  /**
   * Content is loaded via direct src attribute assignment.
   */
  SRC_EQUALS = "SRC_EQUALS"
}
